<script>
  import CommonFormElementMixin from './mixins/CommonFormElement'
  export default {
    mixins: [CommonFormElementMixin],
    props: {
      value: {
        type: File,
        required: false
      },
      previewSrc: String
    },
    computed: {
      isValid () {
        return !this.error || this.error === null
      },
      invalidFeedback () {
        if (!this.error) return ''
        return this.$t('validation.' + Object.keys(this.error)[0])
      },
      inputText () {
        return this.value
          ? this.value.name
          : 'Wybierz plik'
      }
    },
    methods: {
      handleFileUpload ($event) {
        this.$emit('input', $event.target.files[0])
      }
    }
  }
</script>

<template>
  <div class="md-form mt-5 mb-5">
    <div class="fileInputPreview">
      <img :src="previewSrc" />
    </div>
    <label class="mr-5 active">{{ label }}</label>
      <div class="custom-file">
        <input type="file" class="form-control custom-file-input" :class="{ 'is-invalid': !isValid }" @input="handleFileUpload($event)">
        <label class="custom-file-label" for="inputGroupFile01">
          {{ inputText }}
        </label>
        <div class="invalid-feedback">{{ invalidFeedback }}</div>
      </div>
  </div>
</template>

<style lang="scss">
.custom-file {
  .custom-file-label {
    overflow: hidden;
  }
}
.custom-file-input {
  cursor: pointer;
}
.custom-file-input:lang(pl)~.custom-file-label::after {
    content: "Wybierz";
}
.fileInputPreview {
  position: relative;
  top: 15px;
  margin-bottom: 15px;
  img {
    display: block;
    max-width: 100%;
    max-height: 150px;
  }
}
</style>
